import React, { PureComponent } from 'react';
import AudioAnalyzer from '../../utils/audio-context';

const lerp = (v0: number, v1: number, t: number): number => v0 * (1 - t) + v1 * t;

interface AudioMeterProps {
	inputStream?: MediaStream;
	color: string;
}

export default class AudioMeter extends PureComponent<AudioMeterProps> {
	currentVol = 0;

	targetVol = 0;

	radius = 3;

	prevRads = new Float32Array([0, 0, 0, 0, 0]);

	scale = 5;

	ctx: CanvasRenderingContext2D | undefined | null;

	canvas: HTMLCanvasElement | undefined | null;

	analyzer: AudioAnalyzer | undefined;

	interval: number | undefined;

	componentDidUpdate() {
		if (this.props.inputStream && this.props.inputStream.getAudioTracks()[0]) {
			if (this.analyzer) {
				this.analyzer.destroy();
				this.analyzer = undefined;
			}

			this.analyzer = new AudioAnalyzer(this.props.inputStream, this.setVol, 50);
			this.draw();
		}
	}

	setVol = (vol: number) => {
		this.targetVol = vol * this.scale;
	};

	componentDidMount() {
		if (this.props.inputStream && this.props.inputStream.getAudioTracks()[0]) {
			if (this.analyzer) {
				this.analyzer.destroy();
				this.analyzer = undefined;
			}

			this.analyzer = new AudioAnalyzer(this.props.inputStream, this.setVol, 50);
			this.draw();
		}

		this.ctx = this.canvas?.getContext('2d');
	}

	componentWillUnmount() {
		if (this.analyzer) {
			if (this.interval) window.cancelAnimationFrame(this.interval);
			this.analyzer.destroy();
		}
	}

	draw = () => {
		this.interval = window.requestAnimationFrame(this.draw);

		if (!this.canvas) return;
		if (this.targetVol === 0) return;

		this.ctx?.clearRect(0, 0, 160, 120);

		const segments = 160 / 6;
		const yOne = segments * 2;
		const yTwo = segments * 3;
		const yThree = segments * 4;
		const midPoint = 120 / 2;
		this.currentVol = Math.min(lerp(this.targetVol, this.currentVol, 0.8), 50);

		if (this.ctx) {
			this.ctx.beginPath();
			this.ctx.moveTo(yOne, midPoint - this.currentVol / 2);
			this.ctx.lineTo(yOne, midPoint + this.currentVol / 2);
			this.ctx.strokeStyle = this.props.color;
			this.ctx.lineCap = 'round';
			this.ctx.lineWidth = 20;
			this.ctx.stroke();

			this.ctx.beginPath();
			this.ctx.moveTo(yTwo, midPoint - this.currentVol);
			this.ctx.lineTo(yTwo, midPoint + this.currentVol);
			this.ctx.strokeStyle = this.props.color;
			this.ctx.lineCap = 'round';
			this.ctx.lineWidth = 20;
			this.ctx.stroke();

			this.ctx.beginPath();
			this.ctx.moveTo(yThree, midPoint - this.currentVol / 2);
			this.ctx.lineTo(yThree, midPoint + this.currentVol / 2);
			this.ctx.strokeStyle = this.props.color;
			this.ctx.lineCap = 'round';
			this.ctx.lineWidth = 20;
			this.ctx.stroke();
		}
	};

	render() {
		return (
			<canvas width={120} height={120} className="audio-meter" ref={(ref) => { this.canvas = ref; }}></canvas>
		);
	}
}
